import styled, { CSSObject } from '@emotion/styled'
import { ModifierGroup } from 'shop/types/cart'
import { ModifierOptionGroupName } from '../commonStyles'
import Modifier from './Modifier'

interface Props {
  modifierGroups: ModifierGroup[]
}

const ModifierList = ({ modifierGroups }: Props) => {
  const allModifiers = modifierGroups.flatMap(({ modifiers }) => modifiers)

  return (
    <Content data-testid='modifiers'>
      <ModifierOptionGroupName>
        <Modifier modifiers={allModifiers} />
      </ModifierOptionGroupName>
    </Content>
  )
}

const Content = styled.div(
  (): CSSObject => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  })
)

export default ModifierList
